import { createParams } from 'root/utils/URLParams/URLParams';

(function () {
    const pageExperts = document.querySelector('[data-experts]');

    if (pageExperts) {
        let showCardTab = (trigger, content) => {
            trigger.classList.add('active');
            content.classList.add('active');
        };

        let resetCardTab = singleTab => {
            const activeTabs = Array.prototype.slice.call(
                singleTab.querySelectorAll('.active')
            );

            activeTabs.forEach(activeTab => {
                activeTab.classList.remove('active');
            });
        };

        let expertCardTabs = () => {
            const cardTabs = Array.prototype.slice.call(
                pageExperts.querySelectorAll('[data-experts-services]')
            );

            cardTabs.forEach(cardTab => {
                cardTab.addEventListener('click', e => {
                    let productType =
                        e.target.dataset.expertsServicesIcon ||
                        e.target.parentNode.dataset.expertsServicesIcon;
                    let isDisabled =
                        e.target.classList.contains('disabled') ||
                        e.target.parentNode.classList.contains('disabled');

                    if (productType && !isDisabled) {
                        resetCardTab(cardTab);
                        showCardTab(
                            cardTab.querySelector(
                                `[data-experts-services-icon="${productType}"]`
                            ),
                            cardTab.querySelector(
                                `[data-experts-services-content="${productType}"]`
                            )
                        );
                    }
                });
            });
        };

        // Could contain:
        // location: '...',
        // products: '...',
        // services: '...',
        const queryObject = {};

        const setQueryObject = ({ name, value }) => {
            if (name && value && name !== 'installation') {
                queryObject[name] = value;
            }
        };

        const handleFormChange = expertsFormEl => {
            const selectFields = expertsFormEl.querySelectorAll('select');
            selectFields.forEach(selectField => {
                setQueryObject(selectField);
                selectField.addEventListener('change', e => {
                    setQueryObject(e.target);
                    setFormAction(expertsFormEl);
                });
            });
        };

        const setFormAction = expertsFormEl => {
            expertsFormEl.action = getUrlParamsFromQueryObject();
        };

        const getUrlParamsFromQueryObject = () => {
            const urlParams = createParams(queryObject);
            return urlParams ? `?${urlParams}` : '';
        };

        const setLocationParam = () => {
            if (
                queryObject['location'] ||
                queryObject['products'] ||
                queryObject['services']
            ) {
                window.history.replaceState(null, null, getUrlParamsFromQueryObject());
            }
        };

        const initFilterByUrlParam = () => {
            const expertsFormEl = document.querySelector('[data-experts-query]');
            if (expertsFormEl) {
                handleFormChange(expertsFormEl);
                setFormAction(expertsFormEl);
            }
        };

        let init = () => {
            expertCardTabs();
            initFilterByUrlParam();
            setLocationParam();
        };

        return {
            init,
        };
    }
})().init();
